import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import article1 from "../../assets/images/hot-article/article1.png"
import article2 from "../../assets/images/hot-article/article2.png"
import article3 from "../../assets/images/hot-article/article3.png"
import article4 from "../../assets/images/hot-article/article4.png"
import article5 from "../../assets/images/hot-article/article5.png"
import article6 from "../../assets/images/hot-article/article6.png"
import article7 from "../../assets/images/hot-article/article7.png"
import article8 from "../../assets/images/hot-article/article8.png"
import "./hotArticle.css"

const HotArticle = () => {
  return (
    <section className='hot-article text-center'>
      <Container fluid className='custom-container'>
        <div className='heading-sec'>
          <h2 className='h2 mb-2'>Hot Articles</h2>
          <p className='mb-0'>Stay updated with the latest trends and insights</p>
        </div>
        <Row className='g-3'>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article1} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Beauty of Hibiscus BH39</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article2} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Daisy Saree Black 31</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article3} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Ice Green Doppata IGD46</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article4} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Black Forest Maxi BFM20</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article5} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Chocolate Gold CG30</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article6} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Hand Painted Dress with Embailishment</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article7} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Peacock Love PL34</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article8} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-name mb-0 position-relative'>
                  <p className='mb-0'>Black Classic BC38</p>
                </div>
                <button className='yellow-btn'>
                  Shop Now
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HotArticle